/* eslint-disable */
import axios from 'axios'
import i18n from '@/plugins/i18n/i18n'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const signUpMeConfirm = uri => new Promise ((resolve, reject) => {

  const currentLanguage = (i18n.locale == 'en-EN') || (i18n.locale == 'en') ? 'en' :
  (i18n.locale == 'fr-FR') || (i18n.locale == 'fr') ? 'fr' :
  (i18n.locale == 'nl-NL') || (i18n.locale == 'nl') ? 'nl' : 'fr'

  let subject = false
  
  let alert = false
  let alertType = 'error'
  let alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']

  axios.get(randomBaseUrl(0, 3) + process.env.VUE_APP_CREATE_CONFIRM_LOGIN_ENDPOINT + uri)
    .then(response => {
      const status = response.data.status

      // check the response status
      if (status === 'error') {

        subject = response.data.message

        switch (subject) {
          case 'Login does not exists':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['signup-confirm']['alertMsg']['login-not-exist']
            break

          case 'Login too short':
            alertType = 'error'
            alertMessage = params.password.length > 0 ? i18n.messages[currentLanguage]['signup-confirm']['alertMsg']['login-shoort']['msg-1'] : i18n.messages[currentLanguage]['signup-confirm']['alertMsg']['login-shoort']['msg-2']
            break

          default:
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']
            break
        }

        alert = true // show alert box

      } else if (status === 'ok') {

        subject = response.data.answer.validated

        alert = false // remove a potential alert box
        // normally not showing info but we change it just in case
        alertType = 'success'
        alertMessage = i18n.messages[currentLanguage]['signup-confirm']['alertMsg']['success']

        if (subject === 'fail') {
          // fail error (= no key)
          alertType = 'error'
          alertMessage = i18n.messages[currentLanguage]['signup-confirm']['alertMsg']['key']
          alert = true // show alert box
        }

      } else {
        // normaly impossible case with no error but no correct response
        alertType = 'error'
        alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']
        alert = true // show alert box

      }

      resolve({status, subject, alert, alertType, alertMessage})
    })
    .catch(() => {
      localStorage.removeItem('user-token') // if the request fails, remove any possible user token
      this.$store.commit('auth/authLogout')

      // error
      alertType = 'error'
      alertMessage = i18n.messages[currentLanguage]['basic-message']['error-message']
      alert = true // show alert box

      reject({
        alert: alert,
        alertType: alertType,
        alertMessage: alertMessage
      })
    })
})
